import { Dispatch, SetStateAction } from "react";
import { fetchCompanyRoles } from "../_actions/employer.actions";

export const getCompanyRoleList = async ({
	companyId,
	setRoleList,
}: {
	companyId: string;
	setRoleList?: Dispatch<SetStateAction<Role[]>>;
}) => {
	try {
		const response: Role[] = await fetchCompanyRoles({ companyId });
		if (setRoleList) {
			setRoleList(response || []);
		}
		return response;
	} catch (error) {
		console.error("Error fetching company roles:", error);
		throw error;
	}
};
